import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/** Heading above the credits body. */
export function BlockNamePlacementVerticalIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M4 3h16v3H4V3z" />
      <path fillRule="evenodd" d="M4 8h16v13H4V8zm2 2v9h12v-9H6z" />
    </SvgIcon>
  );
}

/** Heading to the left of the credits body. */
export function BlockNamePlacementHorizontalLeftIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M3 4h3v16H3V4z" />
      <path fillRule="evenodd" d="M8 4h12v16H8V4zm2 2v12h8V6h-8z" />
    </SvgIcon>
  );
}

/** Heading to the right of the credits body. */
export function BlockNamePlacementHorizontalRightIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path fillRule="evenodd" d="M4 4h12v16H4V4zm2 2v12h8V6H6z" />
      <path d="M18 4h3v16h-3V4z" />
    </SvgIcon>
  );
}
